<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <p class="hint">
      买家在退货预约寄件支付运费后，卖家责任订单须先支付退货运费方可确认收货；支付后系统自动原路退回买家。亦可提交申诉由平台审核；卖家超时未确认收货时系统将自动确认并退回申诉运费。
    </p>

    <div class="table-scroll-wrap">
    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="id" label="寄件单ID" width="90" align="center" />
      <el-table-column prop="pickupNo" label="寄件单号" min-width="160" align="center" show-overflow-tooltip />
      <el-table-column prop="secondhandOrderNo" label="订单号" min-width="170" align="center" show-overflow-tooltip />
      <el-table-column prop="refundApplyId" label="退款申请ID" width="110" align="center" />
      <el-table-column prop="buyerUserId" label="买家ID" width="90" align="center" />
      <el-table-column label="运费(元)" width="100" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.payAmount) }}</template>
      </el-table-column>
      <el-table-column prop="freightAppealReason" label="申诉说明" min-width="200" show-overflow-tooltip />
      <el-table-column label="申诉时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="approveRow(scope.row)">同意退运费</el-button>
          <el-button type="danger" size="mini" plain @click="rejectRow(scope.row)">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "SecondhandPickupFreightAppeal",
  data() {
    return {
      historyArr: ["退款管理", "退货运费申诉"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    fetchList(page) {
      this.loading = true;
      const url = `${this.$api.api.mgmtPickupFreightAppealPending}?page=${page || 1}&size=${this.pageSize}`;
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    approveRow(row) {
      if (!row || !row.id) return;
      this.$confirm("确认同意申诉并原路退回该笔退货运费？", "同意退运费", {
        type: "warning",
      })
        .then(() => {
          const url = `${this.$api.api.mgmtPickupFreightAppealApprove}?pickupOrderId=${encodeURIComponent(
            row.id
          )}`;
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已原路退回运费");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
    rejectRow(row) {
      if (!row || !row.id) return;
      this.$prompt("请填写驳回说明（可选）", "驳回申诉", {
        confirmButtonText: "驳回",
        cancelButtonText: "取消",
        inputPlaceholder: "驳回原因",
      })
        .then(({ value }) => {
          const reason = value != null ? String(value).trim() : "";
          let url = `${this.$api.api.mgmtPickupFreightAppealReject}?pickupOrderId=${encodeURIComponent(row.id)}`;
          if (reason) {
            url += `&rejectReason=${encodeURIComponent(reason)}`;
          }
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已驳回");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandPickupFreightAppeal/index.vue